import * as React from 'react';
import Box from '@mui/material/Box';

const CustomNoRowsOverlay = () => {
    return (
        <>
            <Box sx={{ mx: 'auto', mt: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>No data available</Box>
        </>
    );
}

export default CustomNoRowsOverlay;